module.exports = __webpack_public_path__ + "media/images/jlp-trust-safety-chelsea-a0123444ce86df6212f509e9e3ee8026.png";